import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const VAM_RECEIVE_TUTORIAL = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'VAM_RECEIVE_TUTORIAL')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: '/cgs/api/personal/vam/v2/auth/query-info',
        requestAction: VAM_RECEIVE_TUTORIAL.INIT_REQUEST,
        successAction: VAM_RECEIVE_TUTORIAL.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [VAM_RECEIVE_TUTORIAL.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [VAM_RECEIVE_TUTORIAL.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'vamReceiveTutorial',
    reducerMap: {
      vamReceiveTutorialState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
